var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bx-link-external.svg"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.74998 2.25L12.2197 4.71975L6.96973 9.96975L8.03023 11.0302L13.2802 5.78025L15.75 8.25V2.25H9.74998Z",
    fill: "#0009E8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.25 14.25H3.75V3.75H9L7.5 2.25H3.75C2.92275 2.25 2.25 2.92275 2.25 3.75V14.25C2.25 15.0773 2.92275 15.75 3.75 15.75H14.25C15.0773 15.75 15.75 15.0773 15.75 14.25V10.5L14.25 9V14.25Z",
    fill: "#0009E8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkIcon);
export default __webpack_public_path__ + "static/media/link_icon.bb9a9f53365fae2d1832110ccc7e64aa.svg";
export { ForwardRef as ReactComponent };